export const DEFAULT_CONFIG = {
  TASK_END_DATE_OFFSET_HOURS: 24,
  MEETING_DURATION_OPTIONS: [
    { value: 0.25, labelKey: "duration.15minutes" },
    { value: 0.5, labelKey: "duration.30minutes" },
    { value: 1, labelKey: "duration.1hour" },
    { value: 2, labelKey: "duration.2hours" },
    { value: 3, labelKey: "duration.3hours" },
    { value: 24, labelKey: "duration.1day" },
  ],
};
